import {ComponentProps, forwardRef} from 'react'
import {NavLinkLink} from './NavLinkLink'

export type NavLinkAccountProps = ComponentProps<typeof NavLinkLink>

export const NavLinkAccount = forwardRef<any, NavLinkAccountProps>(
  ({label, href}, ref) => (
    <NavLinkLink label={label || 'My Account'} href={href} ref={ref} />
  ),
)
